// one file because we actually need them at initialization time of all core data
angular.module('cfn').controller('fieldPopupController', [
  '$scope',
  '$rootScope',
  '$http',
  function($scope, $rootScope, $http) {
    corePopupListController(
      this,
      $http,
      $scope,
      $rootScope,
      'field',
      '/365FarmNet/rest/core/field'
    );
    $scope.fieldPopupController = this;
    return $scope.fieldPopupController;
  }
]);
angular.module('cfn').controller('fieldGroupPopupController', [
  '$scope',
  '$rootScope',
  '$http',
  function($scope, $rootScope, $http) {
    corePopupListController(
      this,
      $http,
      $scope,
      $rootScope,
      'fieldGroup',
      '/365FarmNet/rest/core/fieldgroup'
    );
    $scope.fieldGroupPopupController = this;
    return $scope.fieldGroupPopupController;
  }
]);

angular.module('cfn').controller('possessionPopupController', [
  '$scope',
  '$rootScope',
  '$http',
  function($scope, $rootScope, $http) {
    corePopupListController(
      this,
      $http,
      $scope,
      $rootScope,
      'possession',
      '/365FarmNet/rest/core/possession'
    );
    $scope.possessionPopupController = this;
    return $scope.possessionPopupController;
  }
]);
angular.module('cfn').controller('farmPopupController', [
  '$scope',
  '$rootScope',
  '$http',
  function($scope, $rootScope, $http) {
    corePopupListController(
      this,
      $http,
      $scope,
      $rootScope,
      'farm',
      '/365FarmNet/rest/core/farm'
    );
    $scope.farmPopupController = this;
    return $scope.farmPopupController;
  }
]);
angular.module('cfn').controller('machinePopupController', [
  '$scope',
  '$rootScope',
  '$http',
  'ShopService',
  function($scope, $rootScope, $http, ShopService) {
    corePopupListController(
      this,
      $http,
      $scope,
      $rootScope,
      'machine',
      '/365FarmNet/rest/core/machine'
    );
    this.hasModuleCLA = ShopService.isProductLicensed('CLA');
    $scope.machinePopupController = this;
    return $scope.machinePopupController;
  }
]);
angular.module('cfn').controller('personPopupController', [
  '$scope',
  '$rootScope',
  '$http',
  function($scope, $rootScope, $http) {
    corePopupListController(
      this,
      $http,
      $scope,
      $rootScope,
      'person',
      '/365FarmNet/rest/core/person'
    );
    $scope.personPopupController = this;
    return $scope.personPopupController;
  }
]);
angular.module('cfn').controller('personGroupPopupController', [
  '$scope',
  '$rootScope',
  '$http',
  function($scope, $rootScope, $http) {
    corePopupListController(
      this,
      $http,
      $scope,
      $rootScope,
      'personGroup',
      '/365FarmNet/rest/core/persongroup'
    );
    $scope.personGroupPopupController = this;
    return $scope.personGroupPopupController;
  }
]);
angular.module('cfn').controller('fertilizerPopupController', [
  '$scope',
  '$rootScope',
  '$http',
  function($scope, $rootScope, $http) {
    corePopupListController(
      this,
      $http,
      $scope,
      $rootScope,
      'fertilizer',
      '/365FarmNet/rest/core/fertilizer'
    );
    $scope.fertilizerPopupController = this;
    return $scope.fertilizerPopupController;
  }
]);
angular.module('cfn').controller('plantProtectantPopupController', [
  '$scope',
  '$rootScope',
  '$http',
  function($scope, $rootScope, $http) {
    corePopupListController(
      this,
      $http,
      $scope,
      $rootScope,
      'plantProtectant',
      '/365FarmNet/rest/core/plantprotectant'
    );
    $scope.plantProtectantPopupController = this;
    return $scope.plantProtectantPopupController;
  }
]);
angular.module('cfn').controller('seedPopupController', [
  '$scope',
  '$rootScope',
  '$http',
  function($scope, $rootScope, $http) {
    corePopupListController(
      this,
      $http,
      $scope,
      $rootScope,
      'seed',
      '/365FarmNet/rest/core/seed'
    );
    $scope.seedPopupController = this;
    return $scope.seedPopupController;
  }
]);
angular.module('cfn').controller('cropSequencePopupController', [
  '$scope',
  '$rootScope',
  '$http',
  function($scope, $rootScope, $http) {
    corePopupListController(
      this,
      $http,
      $scope,
      $rootScope,
      'cropSequence',
      '/365FarmNet/rest/core/cropsequence'
    );
    $scope.cropSequencePopupController = this;
    return $scope.cropSequencePopupController;
  }
]);
angular.module('cfn').controller('sysManufacturerPopupController', [
  '$scope',
  '$rootScope',
  '$http',
  function($scope, $rootScope, $http) {
    corePopupListController(
      this,
      $http,
      $scope,
      $rootScope,
      'sysManufacturer',
      '/365FarmNet/rest/core/sysmanufacturer'
    );
    $scope.sysManufacturerPopupController = this;
    return $scope.sysManufacturerPopupController;
  }
]);
angular.module('cfn').controller('sysCulturePopupController', [
  '$scope',
  '$rootScope',
  '$http',
  function($scope, $rootScope, $http) {
    corePopupListController(
      this,
      $http,
      $scope,
      $rootScope,
      'sysCulture',
      '/365FarmNet/rest/core/sysculture'
    );
    $scope.sysCulturePopupController = this;
    return $scope.sysCulturePopupController;
  }
]);
